import { Dispatch, FC, SetStateAction } from 'react';
import { GroupsItemUser } from './GroupsItemUser';
import { typePreachingGroup, typeUser } from '@monorepo/models';
import { useGetIsDarkMode } from 'src/custom-hooks';
import Select from 'react-select';

type propsType = {
    group: typePreachingGroup;
    groups: typePreachingGroup[];
    numberConfirmed: boolean;
    readOnly?: boolean;
    setGroups: Dispatch<SetStateAction<typePreachingGroup[] | null>>;
    users: typeUser[];
};

export const GroupsItem: FC<propsType> = ({ group, groups, numberConfirmed, readOnly, setGroups, users }) => {
    const isDarkMode = useGetIsDarkMode();

    return (
        <div key={group.numberOfGroup}
            className={`card ${(readOnly || !numberConfirmed) ? 'col-lg-6' : ''} ${isDarkMode ? 'bg-dark' : ''} my-3`}
        >
            <div className={`card-header ${isDarkMode ? 'bg-dark text-white' : ''} border mt-2`}>
                <div className={'row'}>
                    <div className={'col-6'}>
                        <h4 className={'pt-1'}>
                            Grupo {group.numberOfGroup}
                        </h4>
                    </div>
                    <div className={'col-6'}>
                        {!readOnly && numberConfirmed &&
                            <Select
                                className={isDarkMode ? 'text-dark' : ''}
                                options={users.filter(u => !groups.map(g => g.users.map(_u => _u.id)).flat().includes(u.id))}
                                getOptionLabel={u => `${u.name} ${u.lastName} (${u.email})`}
                                getOptionValue={u => u.id.toString()}
                                placeholder={'Agregar'}
                                value={null as unknown as typeUser}
                                onChange={u => {
                                    if (!u) return;
                                    setGroups(x => x!.map(g => g.numberOfGroup === group.numberOfGroup ? ({
                                        ...g,
                                        users: [...g.users, {
                                            ...u,
                                            groupIsTheAssistance: false,
                                            groupIsTheOverseer: false
                                        }]
                                    }) : g));
                                }}
                                isClearable
                                isDisabled={!numberConfirmed}
                            />
                        }
                    </div>
                </div>
            </div>
            <div className={`card-body ${isDarkMode ? 'bg-lightdark text-white' : ''}`}>
                {[...group.users].sort((u1, u2) => u1.groupIsTheOverseer !== u2.groupIsTheOverseer ?
                    (u1.groupIsTheOverseer ? -1 : 1)
                    :
                    u1.groupIsTheAssistance !== u2.groupIsTheAssistance ?
                        (u1.groupIsTheAssistance ? -1 : 1)
                        :
                        u1.lastName!.localeCompare(u2.lastName!) || u1.name!.localeCompare(u2.name!)
                ).map(u =>
                    <GroupsItemUser key={u.id}
                        group={group}
                        groupUser={u}
                        numberConfirmed={numberConfirmed}
                        readOnly={readOnly}
                        setGroups={setGroups}
                    />
                )}
            </div>
            <div className={`card-footer ${isDarkMode ? 'bg-dark text-white' : ''} border fw-bolder mb-1`}>
                Cantidad de hermanos: {group.users.length}
            </div>
        </div>
    );
}
